export default function convertFileSize (size: number) {
    if (size >= 1024) {
        return Math.round((size / 1024 + Number.EPSILON) * 100) / 100;
    }

    return size;
}